<script>
    import {sortBy} from 'lodash-es';
    export let value = [];
    export let disabled = false;

    let fieldData = {
        framework: "NIST CSF",
        control: ""
    };

    function removeReference(reference) {
        value = value.filter((r) => r != reference);
    }

    function addReference(evt) {
        if (fieldData.control == ""){
            return
        }

        // copy fieldData
        let reference = JSON.parse(JSON.stringify(fieldData));

        value = [...value, reference];
        fieldData.control = ""
    }

    function handleEnter(evt) {
        if (evt.keyCode == 13) {
            evt.preventDefault();
            evt.stopPropagation();
            addReference();
            return false;
        }
    }


</script>

<div class="content tag_group">
    {#if value}
        {#each sortBy(value, ['framework']) as reference}
            <div class="control">
                <div class="tags has-addons">
                    <span class="tag is-dark">{reference.framework}</span>
                    <span class="tag is-info">
                        {reference.control}
                    </span>
                    {#if !disabled}
                    <span class="tag is-delete link" on:click={() => removeReference(reference)}></span>
                    {/if}
                </div>
            </div>
        {/each}
    {/if}
</div>
{#if !disabled}
<div class="content">
    <div class="field has-addons">
        <p class="control">
            <span class="select">
                <select name="framework" bind:value={fieldData.framework}>
                    <option>NIST CSF</option>
                    <option>CIS CSC</option>
                    <option>SEC</option>
                    <option>HIPAA</option>
                    <option>ISO</option>
                    <option>CIS CSC v8</option>
                    <option>Other</option>
                </select>
            </span>
        </p>
        <p class="control is-expanded ">
            <input class="input" type="text" name="control" placeholder="Control" bind:value={fieldData.control} on:keypress={handleEnter}>
        </p>
        <p class="control">
            <span class="button is-primary" on:click={addReference}>
                Add Reference
            </span>
        </p>
    </div>
</div>
{/if}